import React from 'react'
import banner from '../../assets/Carousel/St Albans Banner 02.jpg'

const DocumentScan = () => {
  return (
    <div>
      <div className='relative w-full h-full mb-5 sm:mb-16'>
        <img src={banner} alt="offset banner"/>
        <div className='absolute top-0 w-full h-full bg-black/40 flex items-center justify-center'>
          <h1 className='text-2xl sm:text-4xl font-medium text-white drop-shadow-md'>Document Scanning</h1>
        </div>
      </div>
      <div className='px-5 sm:px-10 pb-8 sm:pb-16'>
        
        <div className='px-4 md:px-14'>
          <div className='sm:px-4 py-6 lg:col-span-3 flex flex-col items-center'>
              <h1 className='text-3xl sm:text-4xl font-bold mb-4 sm:mb-8 text-neutral-800'>Document Scanning</h1>
             <div className='flex flex-col gap-y-3 sm:gap-y-6 text-neutral-700 text-base sm:text-lg'>
  <p className='sm:leading-8'>
    At St. Albans Digital Printing, we recognize the growing challenges of managing paper documents in today’s fast-paced business world. Storing physical files not only consumes valuable office space but also leads to expensive warehousing costs. Our professional document scanning services provide a seamless solution to digitize your records, helping you save time, space, and money. By transforming your paperwork into an organized digital format, we make accessing, managing, and sharing documents effortless while eliminating physical clutter.
  </p> 

  <p className='sm:leading-8'>
   Our expert scanning team utilizes cutting-edge technology to meticulously prepare, scan, and convert a wide range of documents—including invoices, forms, blueprints, books, and medical records—into high-quality digital images. Whether you need standard document scanning or bulk processing, we ensure precision and clarity in every file. Additionally, we specialize in high-quality newsletter printing, offering vibrant, full-color or classic black-and-white designs, premium paper finishes, and digital formats for multi-platform distribution. Our printing services help you create compelling newsletters that engage and inform your audience.
  </p>
               
  <p className='sm:leading-8'>
   To place an order, visit www.stalbansprinting.com or contact us at 718-528-5100 or email us at orders@stalbansprinting.com. Let us assist you in preserving essential documents and producing visually striking printed materials tailored to your needs. With St. Albans Digital Printing, you can streamline document management and enhance communication with ease.
  </p>          

  <p className='sm:leading-8'>
  <strong>Popular Document Scanning Services</strong> 
  </p>
   <p className='sm:leading-8'>
   ➔	Bulk Document Scanning: Fast, high-volume digitization of large file collections.
  </p>
  <p className='sm:leading-8'>
  ➔	Large-Format Scanning: Digitizes blueprints, engineering drawings, and oversized documents.
  </p>
  <p className='sm:leading-8'>
  ➔	Medical Records Scanning: Securely archives patient records while ensuring compliance.
  </p>
  <p className='sm:leading-8'>
  ➔	Legal Document Scanning: Converts contracts and case files into organized digital formats.
  </p>
  <p className='sm:leading-8'>
  ➔	Book Scanning: Preserves books and manuscripts without damaging originals.  
  </p>
  
        

        
</div>


              {/* --- Images from APi  */}
              <div>
                {/* ImageX3 in grid */}
              </div>
          </div>  
        </div>

      </div>
    </div>
  )
}

export default DocumentScan
